/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Largest_ValueInputs */

const en_landing_why_largest_value = /** @type {(inputs: Landing_Why_Largest_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4016 × 6016`)
};

const zh_landing_why_largest_value = /** @type {(inputs: Landing_Why_Largest_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4016 × 6016`)
};

/**
* | output |
* | --- |
* | "4016 × 6016" |
*
* @param {Landing_Why_Largest_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_largest_value = /** @type {((inputs?: Landing_Why_Largest_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Largest_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_largest_value(inputs)
	return zh_landing_why_largest_value(inputs)
});
export { landing_why_largest_value as "landing.why.largest_value" }